export default __webpack_public_path__ + "static/media/EAST1890.34I-40948_-24298_0.4f96728c.jpg";